import committed from '../data/painterStrokes.json';
import {
  painterStrokeRegions,
  parsePainterStrokes,
  type PainterStrokeRegion,
} from './painterStrokes';

/*
 * tools/painterStrokes measures the painting offline and the build bundles what it wrote, so the app
 * decodes no painting at load; the file is held to its schema as the data the app fetches are.
 */
export function painterStrokeRegionsFrom(value: unknown): readonly PainterStrokeRegion[] {
  const parsed = parsePainterStrokes(value);
  if (!parsed.ok) throw new Error(`painterStrokes.json is invalid: ${parsed.error.join('; ')}`);
  return painterStrokeRegions(parsed.value);
}

export function committedPainterStrokes(): readonly PainterStrokeRegion[] {
  return painterStrokeRegionsFrom(committed);
}
